export default {
  secondaryText: "#888",
};



// WEBPACK FOOTER //
// ./src/styles/Colors.js